import useSWR from 'swr';

import { fetcher } from 'src/utils/axios';

const useUnauthenticatedSWR = (endpoint, options = {}) => {
  const { data, error, isValidating, isLoading } = useSWR(
    endpoint,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      ...options,
    }
  );

  // fetcher already handles response transformation via axios interceptor
  return { data: data || null, error, isValidating, isLoading };
};

export default useUnauthenticatedSWR;